// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3mlDw","toolbar":"styles_toolbar__2TrAr","editor":"styles_editor__1M857"};